/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, IconButton, Tooltip, ListItem } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { setSelectedTemplate, getSubTempateDetails, resetSubTempates } from '../Template.actions';
import { useSelector, useDispatch } from 'react-redux';
import quickReportStyle from './QuickReport.style';
import { getTmplName, getDfltFilter } from 'helper/utils';
import {
	QUICK_REPORT,
	BUILD_REPORT,
	FROM_SCRATCH,
	BUILD_TO_TRACK,
	FILTER,
	NO_TEMP_MSG_ONE,
	NO_TEMP_MSG_TWO,
	BASIC_NO_TEMP_MSG_ONE,
	SHOW_AS_CANNED_REPORT,
	USE_THE_DATASET,
	AVAILABLE_FOR_CHARTER_ONLY,
	DATA_PREVIEW,
	TENDER_ANALYSIS_LIST,
	ECOMM_INSTOCK_LIST,
	SHIP_TO_ZIP_LIST,
	CUSTOM_PREVIEW_ATTR
} from 'constants/constant';
import {
	setSelectedList,
	setFilterList,
	clearPreview,
	resetDraft,
	setPrevFilterList,
	setIsMandateCheck,
	saveItemShareStatus,
	getPinnedAttribute
} from 'components/Preview/Preview.actions';
import AddIcon from '@material-ui/icons/Add';
import { UserPortalContext } from 'context/appcontext';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import QuickReportDetails from './QuickReportDetails.component';
import FilterListIcon from '@material-ui/icons/FilterList';
import FilterForm from 'components/Preview/filter/FilterForm.component';
import FooterButton from './FooterButton.component';
import { FEATURES } from 'helper/basicFeatureFlag';
import { colors } from 'theme/color-palette';
import RBButton from 'components/Shared/RBButton';
import { BASIC } from 'constants/constant';
import CloseIcon from '@material-ui/icons/Close';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { handleBuildReport } from './QuickReport.utils';
import classNames from 'classnames';
import { isCalFamily } from 'components/Preview/filter/FilterCondition';
import { isCustomDataset } from 'helper/utils';
import { INITIAL_SSI_COMPATIBILITY } from 'constants/constant';

const { LIGHTER_GREY, DARK_GREY } = colors;

const QuickReport = (props) => {
	const { show, setShow, isTooltipCheck, setIsTooltipCheck } = props;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = quickReportStyle({ isSmallScreen });
	const [selectedTemplateData, setSelectedTemplateData] = useState(null);
	const [isBackAllowed, setIsBackAllowed] = useState(true);
	const [subTemplateName, setSubTemplateName] = useState(QUICK_REPORT);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const isDimFilterMandate = useSelector((state) => state.previewReducer.isDimFilterMandate);
	const isCalFilterApplied = useSelector((state) => state.previewReducer.isCalFilterApplied);
	const [appliedFilterLen, setAppliedFilterLen] = useState(0);
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType } = portalUserContext;
	const { userPersona, blackOut, companyName } = userDetails?.result;
	const {
		DISABLE_QUICK_REPORT: disableQuickReportLink,
		SHOW_PREVIEW_BUTTON: showPreviewButton,
		SHOW_TEMPLATE_NAME: showTemplateName,
		PREVIEW_ATTRIBUTE_ONLY: previewAttributeOnly
	} = FEATURES[customerType].TEMPLATE_PAGE;

	const isCannedReport = SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate));

	const [drawerView, setDrawerView] = useState({
		initialSection: true,
		detailsSection: false,
		filterSection: false
	});
	const [ssiCompatibility, setSSIInCompatibility] = useState(INITIAL_SSI_COMPATIBILITY);
	const reset = () => {
		dispatch(setIsMandateCheck(false));
		setShow(false);
		dispatch(setSelectedTemplate({ templateId: null, view: null, filter: undefined }));
	};

	useEffect(() => {
		if (selectedTemplate !== null) {
			/**
			 * If canned report is being selected
			 */
			if (isCannedReport) {
				const result = cannedReportData.filter(
					(item) => item.templateName === getTmplName(selectedTemplate)
				);
				setSelectedTemplateData(result[0]);
				setSubTemplateName(result[0].templateName);
				dispatch(setIsMandateCheck(false));
				setShow(true);
				setIsBackAllowed(isSmallScreen);
				setDrawerView({
					initialSection: false,
					detailsSection: true,
					filterSection: false
				});
			} else {
				const isCustomDS = isCustomDataset(selectedTemplate);
				const result = templateData.filter(
					(item) => item.templateName === getTmplName(selectedTemplate)
				);
				setSelectedTemplateData(result[0]);
				dispatch(setIsMandateCheck(false));
				// Open the Quick report panel on the right for all the templates except custom dataset templates.
				if (!isCustomDS) {
					setShow(true);
				}
				if (previewAttributeOnly) {
					setSubTemplateName(DATA_PREVIEW);
					setIsBackAllowed(false);
					setDrawerView({
						initialSection: false,
						detailsSection: true,
						filterSection: false
					});
				} else {
					setIsBackAllowed(true);
					setDrawerView({
						initialSection: true,
						detailsSection: false,
						filterSection: false
					});
				}
			}
		} else {
			reset();
		}
	}, [selectedTemplate]);

	useEffect(() => {
		if (isDimFilterMandate) {
			setIsBackAllowed(true);
			setDrawerView({
				initialSection: false,
				detailsSection: false,
				filterSection: true
			});
		}
	}, [isDimFilterMandate]);

	useEffect(() => {
		const appliedFil = filterList?.filter((o) => o.field !== undefined);
		setAppliedFilterLen(appliedFil?.length);
	}, [filterList]);

	useEffect(() => {
		if (
			![...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST, ...ECOMM_INSTOCK_LIST].includes(
				Number(selectedTemplate)
			)
		) {
			return;
		}
		if (!isCalFilterApplied) {
			setIsBackAllowed(true);
			//check if default filter is already included
			if (filterList.some((_o) => isCalFamily(_o))) {
				return;
			}
			const dfltFilter = getDfltFilter([selectedTemplateData], undefined, true);
			let newFilterList = [...filterList, ...dfltFilter];
			dispatch(setFilterList(newFilterList));
			dispatch(setPrevFilterList(newFilterList));
			setDrawerView({
				initialSection: false,
				detailsSection: false,
				filterSection: true
			});
		}
	}, [isCalFilterApplied]);

	useEffect(() => {
		const urlParam = new URLSearchParams(window.location.search);
		if (urlParam.get('notReset')) {
			reset();
		}
		return isSmallScreen && setShow(false);
	}, [isSmallScreen]);

	const handleBack = () => {
		if (drawerView.initialSection) {
			return isSmallScreen ? setShow(!show) : true;
		}
		if (isDimFilterMandate) {
			dispatch(setIsMandateCheck(false));
		}
		if (drawerView.detailsSection) {
			dispatch(setFilterList([]));
			if (isCannedReport) {
				setSubTemplateName(QUICK_REPORT);
				return isSmallScreen ? setShow(!show) : true;
			} else {
				setDrawerView({
					initialSection: true,
					detailsSection: false,
					filterSection: false
				});
				setSubTemplateName(QUICK_REPORT);
			}
		}
		if (drawerView.filterSection) {
			setIsBackAllowed(!isCannedReport);
			setDrawerView({
				initialSection: false,
				detailsSection: true,
				filterSection: false
			});
		}
	};

	const buildReport = () => {
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.BUILD_REPORT_BUTTON} ${selectedTemplateData.templateName}`,
			location: PAGE_ID.TEMPLATES
		});

		const result = templateData.filter(
			(item) => item.templateName === getTmplName(selectedTemplate)
		);

		//if result is not found in templateData, look for item in customTemplateDataList

		const dispatchFilterList = (list) => {
			dispatch(setFilterList(list));
			dispatch(setPrevFilterList(list));
		};

		const dispatchSelectedList = (list) => {
			dispatch(setSelectedList(list));
		};

		handleBuildReport(
			selectedTemplate,
			result,
			userPersona,
			blackOut,
			sbuDBTechNames,
			sbuDepartments,
			selectedView,
			dispatchFilterList,
			dispatchSelectedList
		);

		dispatch(clearPreview([]));
		dispatch(resetDraft());
		dispatch(saveItemShareStatus({ prev: false, curr: false }));
		navigate('/preview');
	};

	const getTemplateDetails = (subtemplateId) => {
		dispatch(getSubTempateDetails({ subtemplateId, templateId: selectedTemplate }));
	};

	const subTemplateClick = (item) => {
		getTemplateDetails(item.subTemplateId);
		setSubTemplateName(item.subTemplateDesc);
		setDrawerView({
			initialSection: false,
			detailsSection: true,
			filterSection: false
		});

		if (selectedTemplate !== null) {
			const allData = [...templateData, ...cannedReportData];
			const result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));

			setSelectedTemplateData(result[0]);
		}
	};

	const CharterNoQuickReportMsg = () => {
		return (
			<Box id="no-template-msg" className={classes.noTemplateMsg}>
				<Box className={classes.noTempMsgOne}>{NO_TEMP_MSG_ONE}</Box>
				<Box>{NO_TEMP_MSG_TWO}</Box>
			</Box>
		);
	};

	const BasicNoQuickReportMsg = () => {
		return (
			<Box id="no-template-msg" className={classes.noTemplateMsg}>
				<Box className={classes.noTempMsgOne}>{BASIC_NO_TEMP_MSG_ONE}</Box>
			</Box>
		);
	};

	const NoQuickReportMsg = () => {
		let _msg = {
			BASIC: BasicNoQuickReportMsg,
			CHARTER: CharterNoQuickReportMsg
		};

		return _msg[customerType]();
	};

	const getSubTemplates = () => {
		const { subTemplates } = selectedTemplateData;
		if (!subTemplates && selectedTemplateData.templateName != 'Store Markup and Markdowns') {
			return <NoQuickReportMsg />;
		}
		return subTemplates?.map((item, index) => {
			const subTemplate = (
				<Box
					id={item.subTemplateId}
					key={`sub-templates-${index}`}
					onClick={() => {
						subTemplateClick(item);
					}}
					className={classes.subTemplates}>
					<Box>
						<span>{BUILD_TO_TRACK}</span>
						<span className={classes.highlightedFont}>
							{item.subTemplateDesc}
							{disableQuickReportLink && (
								<div
									style={{
										background: LIGHTER_GREY,
										height: '17px',
										width: 'auto',
										alignItems: 'center',
										display: 'inline-block',
										padding: '4px',
										margin: '0 8px'
									}}>
									<div style={{ color: DARK_GREY, fontSize: '12px' }}>Charter only</div>
								</div>
							)}
						</span>
					</Box>
					<IconButton
						disabled={disableQuickReportLink}
						aria-label="Close"
						id="clear"
						className={classes.rightArrow}>
						<ArrowForwardIosIcon fontSize="large" style={{ fontSize: '16px' }} />
					</IconButton>
				</Box>
			);
			// For specific customer types, disable the quick report links
			if (disableQuickReportLink) {
				return (
					<ListItem key={index} disabled className={classes.disabledLinkWrapper}>
						{subTemplate}
					</ListItem>
				);
			}
			return subTemplate;
		});
	};

	const previewAttributes = () => {
		setDrawerView({
			initialSection: false,
			detailsSection: true,
			filterSection: false
		});
		setShow(true);
	};
	/**
	 * For charter & basic user
	 * Initial Button(first step button) component
	 */
	let firstStepButton = null;
	if (drawerView.initialSection) {
		firstStepButton = (
			<Box className={classes.buttonContainer}>
				<Box
					id="build-report"
					onClick={() => {
						dispatch(
							getPinnedAttribute({
								companyName,
								templateId: selectedTemplate
							})
						);
						dispatch(resetSubTempates());
						buildReport();
					}}
					className={classes.scratch}>
					<AddIcon fontSize="medium" className={classes.addIcon} />
					{customerType === BASIC ? (
						<Box>
							<span className={classes.normalFont}>{USE_THE_DATASET}</span>
						</Box>
					) : (
						<Box>
							<span className={classes.normalFont}>{BUILD_REPORT}</span>
							<span className={classes.highlightedFont}>{` ${FROM_SCRATCH}`}</span>
						</Box>
					)}
				</Box>
			</Box>
		);
		// Basic user has access to only 'Preview attributes'
		const showPreviewAttributesBtn = showPreviewButton && selectedTemplateData?.isDisabled;
		if (showPreviewAttributesBtn) {
			firstStepButton = (
				<Box className={classes.previewBtnContainer}>
					<RBButton
						id="build-report"
						cbHandleClick={previewAttributes}
						btnName={CUSTOM_PREVIEW_ATTR}
						type="primary"
					/>
				</Box>
			);
		}
	}

	const getClassName = () => {
		const { titleFont, titleFontOnly } = classes;

		const isTitleOnly =
			(isCannedReport && !isBackAllowed) || (previewAttributeOnly && !isCannedReport);
		if (isCannedReport && !isBackAllowed && !previewAttributeOnly) {
			return classNames({ [titleFont]: true });
		}
		return classNames({
			[titleFont]: !isTitleOnly,
			[titleFontOnly]: isTitleOnly
		});
	};

	let titleComponent = null;
	let filterComponent = null;
	if (!drawerView.initialSection) {
		titleComponent = (
			<Typography className={getClassName()}>
				<Tooltip title={subTemplateName} arrow classes={{ tooltip: classes.tooltipCapitalize }}>
					<span className={classes.titleText}>{subTemplateName}</span>
				</Tooltip>
			</Typography>
		);
		filterComponent = (
			<Box>
				<Typography className={classes.titleFont}>
					<span
						className={
							previewAttributeOnly
								? `${classes.filterBasic} ${classes.floatRight}`
								: `${classes.filter} ${classes.floatRight}`
						}
						onClick={() => {
							if (previewAttributeOnly && !isCannedReport) {
								setShow(false);
							} else {
								setIsBackAllowed(true);
								setDrawerView({
									initialSection: false,
									detailsSection: false,
									filterSection: true
								});
								if (
									[...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST, ...ECOMM_INSTOCK_LIST].includes(
										Number(selectedTemplate)
									)
								) {
									//check if default filter is already included
									if (filterList.some((_o) => isCalFamily(_o))) {
										return;
									}
									const dfltFilter = getDfltFilter([selectedTemplateData], undefined, true);
									let newFilterList = [...filterList, ...dfltFilter];
									dispatch(setFilterList(newFilterList));
									dispatch(setPrevFilterList(newFilterList));
								}
							}
						}}
						id="filter-txt-lbl"
						style={{ display: 'flex' }}>
						{previewAttributeOnly && !isCannedReport ? (
							<CloseIcon />
						) : (
							<>
								<FilterListIcon fontSize="small" className={classes.filterList} />
								{FILTER}
								{` (${appliedFilterLen})`}
							</>
						)}
					</span>
				</Typography>
			</Box>
		);
		/**
		 * For Basic users, template name will be shown on Title
		 * Filter should be hidden
		 */
		const showTemplateTitle = showTemplateName && selectedTemplateData?.isDisabled;
		if (showTemplateTitle) {
			titleComponent = (
				<Typography style={{ marginLeft: '4px' }}>
					<span className={getClassName()}>{subTemplateName}</span>
					<Box className={classes.charterOnlyBox}>
						<Box>
							<LockOutlinedIcon style={{ height: '16px' }} /> {selectedTemplateData?.templateName}
							{AVAILABLE_FOR_CHARTER_ONLY}
						</Box>
					</Box>
				</Typography>
			);
		}
	}

	let heightDiff = '150px';
	if (selectedTemplateData?.isDisabled && previewAttributeOnly) {
		heightDiff = '0px';
	}

	const updateSSIComptability = (_d) => {
		setSSIInCompatibility(_d);
	};

	return (
		<Box className={classes.drawerContainer} height={`calc(100vh - ${heightDiff})`}>
			<Box
				aria-controls="template-attribute-header"
				className={classes.titleContainer}
				id="template-attribute-header">
				{isSmallScreen || !drawerView.initialSection ? (
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Box
							className={
								selectedTemplateData?.isDisabled && previewAttributeOnly
									? `${classes.hugeTitleWrapper}`
									: `${classes.titleWrapper}`
							}>
							{isBackAllowed ? (
								<IconButton
									id="back-icon"
									aria-label="back-icon"
									size="medium"
									onClick={handleBack}
									className={classes.backButton}>
									<ArrowBackIcon fontSize="inherit" />
								</IconButton>
							) : null}
							{/* Sub template title  */}
							{titleComponent}
						</Box>
						{/* Filter button */}
						{!drawerView.initialSection && filterComponent}
					</Box>
				) : (
					<Typography className={classes.titleFont}>{QUICK_REPORT}</Typography>
				)}
			</Box>
			{drawerView.initialSection && (
				<Box className={classes.content}>{selectedTemplateData && getSubTemplates()}</Box>
			)}
			{drawerView.detailsSection &&
				selectedTemplateData !== null &&
				selectedTemplateData !== undefined && (
					<QuickReportDetails
						selectedTemplateData={selectedTemplateData}
						show={show}
						setIsTooltipCheck={setIsTooltipCheck}
						isTooltipCheck={isTooltipCheck}
						subTemplateName={subTemplateName}
					/>
				)}
			{/* Initial / First Section Button */}
			{firstStepButton}

			{drawerView.filterSection && (
				<Box>
					<Box>
						<FilterForm
							// FIXME: cbSetShowPreviewElement should be a function. drawerView.filterSection is a boolean
							cbSetShowPreviewElement={drawerView.filterSection}
							usrSelection={[]}
							fromWhere="quickReport"
							cbSSIComptability={updateSSIComptability}
							ssiCompatibility={ssiCompatibility}
						/>
					</Box>
					<FooterButton
						isTooltipCheck={isTooltipCheck}
						setIsTooltipCheck={setIsTooltipCheck}
						show={show}
						showTooltip={false}
						selectedTemplateData={selectedTemplateData}
						subTemplateName={subTemplateName}
					/>
				</Box>
			)}
		</Box>
	);
};

QuickReport.propTypes = {
	setShow: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired,
	setIsTooltipCheck: PropTypes.func.isRequired,
	isTooltipCheck: PropTypes.bool.isRequired
};

export default QuickReport;
